function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
if (!customElements.get("vimeo-video")) {
  class CustomVimeoVideo extends HTMLElement {
    constructor() {
      super();

      this.options = {
        id: "",
        fullscreen: {
          enabled: 1,
        },
      };

      if (window.innerWidth <= 768) {
        this.options.portrait = true;
      }

      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      if (this.options.id === "") {
        debug() && console.error("Vimeo ID is missing");
        return;
      }

      this.links = this.querySelectorAll("a");
      this.videoTriggers = this.querySelectorAll("[data-video-trigger]");
      this.videoWrapper = this.closest("[data-video-wrapper]");
      this.videoWrapper = this.closest("[data-video-wrapper]");
      //console.log('this.videoWrapper=====>',this.videoWrapper);
      this.overlayImage = this.videoWrapper.querySelector("[data-video-overlay-image]");
      //console.log('this.overlayImage=====>',this.overlayImage);
      this.overlayMobImage = this.videoWrapper.querySelector("[data-video-overlay-image-mobile]");
      this.overlayText = this.videoWrapper.querySelector("[data-video-text-overlay]");

      // catch click on links that should not trigger the video
      this.links?.forEach((link) =>
        link.addEventListener("click", function (event) {
          event.stopImmediatePropagation();
        }),
      );

      // load the video
      if (typeof Vimeo !== "undefined") {
        this.player = new Vimeo.Player(`vimeo_${this.options.id}`, this.options);
        this.bindVimeoEvents();
      }

      this.debouncedOnLoad = debounce((event) => {
        this.videoObserver(event);
      }, 100);

      // when autoplay is enabled, check if the video is in viewport and play it (if it's not in a slider)
      if (this.options.autoplay === true || this.options.autoplay === "true") {
        // mute video        
        this.player.setVolume(0);

        // pause autoplay in slider and let videoObserver determine if it should play
        if (this.closest(".swiper-slide") !== null && this.closest(".swiper")?.classList.contains("swiper-initialized")) {
          this.pauseVideo();
        }

        // play video on scroll
        window.addEventListener("scroll", this.debouncedOnLoad.bind(this));

        // play video if it's visible on load
        window.addEventListener("load", this.debouncedOnLoad.bind(this));
      }
    }

    videoObserver(event) {
      const self = this;
      // Register IntersectionObserver
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const elementBounds = entry.boundingClientRect;
          const isSlideLeft = !!elementBounds.left == 0;
          const isBottomVisible =
            !!(elementBounds.bottom < window.innerHeight) && elementBounds.bottom;
          const isTopVisible = !!(elementBounds.top > 0) && elementBounds.top;
          if (entry.target.closest(".swiper-slide") !== null) {
            if (isBottomVisible && isTopVisible && isSlideLeft) {
              self.playVideo();
            }
          } else if (isBottomVisible && isTopVisible) {
            self.playVideo();
          } else {
            self.pauseVideo();
          }
        });
      });
      if (this.videoWrapper.dataset.videoIsPaused !== "true") {
        observer.observe(this);
      }
    }

    bindVimeoEvents() {
      const self = this;

      this.videoTriggers.forEach((trigger) =>
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          self.playVideo();
        }),
      );

      this.player.on("play", function () {
        self.videoWrapper.dataset.videoIsPaused = "false";
        self.hidePlayerElements();
      });

      // When video is paused
      this.player.on("pause", function () {
        self.videoWrapper.dataset.videoIsPaused = "true";
        self.showPlayerElements();
      });

      this.player.on("ended", function () {
        self.videoWrapper.dataset.videoIsPaused = "true";
        self.showPlayerElements();
      });
    }

    playVideo() {
      this.player.play();
      this.hidePlayerElements();
    }

    pauseVideo() {
      this.player.pause();
      this.showPlayerElements();
    }

    hidePlayerElements() {
      if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
        this.overlayMobImage?.classList.add("hidden");
      }
      this.videoTriggers[0]?.classList.add("hidden");
      this.overlayImage?.classList.add("hidden");
      this.overlayText?.classList.add("hidden");
    }

    showPlayerElements() {
      if (window.innerWidth <= parseInt(this.overlayMobImage?.dataset.bp)) {
        this.overlayMobImage?.classList.remove("hidden");
      }
      this.videoTriggers[0]?.classList.remove("hidden");
      this.overlayImage?.classList.remove("hidden");
      this.overlayText?.classList.remove("hidden");
    }
  }

  window.CustomVimeoVideo = CustomVimeoVideo;
  customElements.define("vimeo-video", CustomVimeoVideo);
}
